<template>
  <Modal
    ref="modalRef"
    title=""
    :show-icon="false"
    :click-to-close="true"
    with-closer
    positive-action-text="Tamam"
    negative-action-text=""
    :modal-style="{ width: '460px' }"
    @on-positive-action-click="close"
  >
    <template #body>
      <div class="commission-campaign-alert">
        <div class="commission-campaign-alert-icon">
          <StatusIcon type="info" />
        </div>
        <h3 class="commission-campaign-alert-title">
          {{ alertTitle }}
        </h3>
        <p class="commission-campaign-alert-text">
          {{ alertMessage }}
        </p>
      </div>
    </template>
  </Modal>
</template>

<script setup>
import { ref, defineExpose } from 'vue';
import { Modal, StatusIcon } from '@n11/so-ui-components';

const modalRef = ref(null);
const alertTitle = ref('');
const alertMessage = ref('');

const open = ({ title = '', message = '' } = {}) => {
  alertTitle.value = title;
  alertMessage.value = message;
  modalRef.value?.openModal?.();
};

const close = () => {
  modalRef.value?.hiddenModal?.();
};

defineExpose({
  open,
  close,
});
</script>

<style scoped lang="scss">
.commission-campaign-alert {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8px 8px 4px;
  gap: 16px;
  text-align: center;

  .commission-campaign-alert-icon {
    display: flex;
    justify-content: center;
  }

  .commission-campaign-alert-title {
    margin: 0;
    font-size: 20px;
    font-weight: 700;
    letter-spacing: -0.2px;
    line-height: 26px;
  }

  .commission-campaign-alert-text {
    margin: 0;
    font-size: 16px;
    font-weight: 400;
    letter-spacing: -0.05px;
    line-height: 24px;
  }
}
</style>
